import { useEffect, useState } from "react";
import https from "../pluggins/http";

/**
 * Hook para detectar el estado de conexión del usuario
 * Combina navigator.onLine con un health check periódico al servidor
 * 
 * @returns {boolean} true si hay conexión, false si está offline
 */
export const useConnectionStatus = () => {
  const [isOnline, setIsOnline] = useState(
    typeof window !== "undefined" ? window.navigator.onLine : true
  );

  useEffect(() => {
    // Health check al servidor cada 5 segundos
    const healthCheckInterval = setInterval(async () => {
      // Si navigator.onLine dice que está offline, confiamos en eso
      if (!window.navigator.onLine) {
        setIsOnline(false);
        return;
      }

      // Si navigator.onLine dice que está online, validamos con el servidor
      try {
        // Hacer una petición rápida al servidor para verificar conexión real
        const response = await https.get("health", {
          timeout: 3000, // Timeout de 3 segundos
        });
        
        if (response.status === 200) {
          setIsOnline(true);
        } else {
          setIsOnline(false);
        }
      } catch (error) {
        // Si falla la petición, asumimos que no hay conexión
        setIsOnline(false);
        console.debug("Health check failed:", error.message);
      }
    }, 5000); // Cada 5 segundos

    // Escuchar cambios de online/offline
    const handleOnline = () => setIsOnline(true);
    const handleOffline = () => setIsOnline(false);

    window.addEventListener("online", handleOnline);
    window.addEventListener("offline", handleOffline);

    return () => {
      clearInterval(healthCheckInterval);
      window.removeEventListener("online", handleOnline);
      window.removeEventListener("offline", handleOffline);
    };
  }, []);

  return isOnline;
};
